<template>
  <a :href="item.attributes.url + '?start_date=' + start_date + '&end_date=' + end_date" class="bg-white w-full relative rounded-lg min-w-[280px] xl:min-w-full">
    <div v-if="item.attributes.delivery_enabled && this.item.attributes.itype !== 1" class="bg-white rounded-lg px-2 py-1 absolute top-2 left-2 text-xs font-bold">
      {{ i18n.t('marketplace.general.delivery') }}
    </div>
    <div v-if="item.attributes.transport_enabled && this.item.attributes.itype == 1" class="bg-white rounded-lg px-2 py-1 absolute top-2 left-2 text-xs font-bold">
      {{ i18n.t('marketplace.general.transport') }}
    </div>
    <img v-if="item.attributes.main_image" :src="item.attributes.main_image" class="object-cover aspect-square w-full rounded-xl" />
    <div v-else class="aspect-square w-full flex items-center justify-center rounded-xl bg-gray-100">
      <span class="fa-stack text-[72px] opacity-20 ">
        <i class="fa-image far fa-stack-1x" aria-hidden="true"></i>
        <i class="fa-slash fas icon-stack-base fa-stack-1x " aria-hidden="true"></i>
      </span>
    </div>
    <h6 class="block truncate font-bold mt-2 mb-1">{{ item.attributes.name }}</h6>
    <div class="flex item-center gap-2 text-gray-500 font-medium mb-2">
      <span class="truncate">{{ item.attributes.locations.region }}</span>
      <span>•</span>
      <span class="truncate">{{ item.attributes.locations.city }}</span>
    </div>
    <div class="flex items-center gap-2 font-semibold text-mk-dark-blue text-sm">
      <div v-if="item.attributes.google_rating" class="shrink-0 py-1 px-2 rounded-lg bg-gray-100">
        <span>
          <i class="bi bi-star"></i>
          <span>{{ item.attributes.google_rating }}</span>
        </span>
      </div>
      <div v-if="item.attributes.duration || item.attributes.size" class="shrink-0 py-1 px-2 rounded-lg bg-gray-100">
        <template v-if="item.attributes.itype == 1">
          {{ item.attributes.duration }}
        </template>
        <template v-if="item.attributes.size">
          {{ item.attributes.size }}
        </template>
      </div>
      <div class="shrink-0 py-1 px-2 rounded-lg bg-gray-100">
          <template v-if="item.attributes.tiered_price">{{ i18n.t('marketplace.general.from') }}</template>
          {{ item.attributes.price }}
          {{ item.attributes.currency_symbol }}
        </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "CardComponent",
  props: {
    item: {
      type: Object,
      required: true
    },
    start_date: {
      type: String,
      required: false
    },
    end_date: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      // Define any local state needed for the card component
    };
  }
}
</script>